"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateCategoryCircuitDto = void 0;
class UpdateCategoryCircuitDto {
    name;
    categoryIds;
    tagIds;
    displayIds;
    color;
    background;
    image;
    description;
    order;
    featured;
    is_archived;
}
exports.UpdateCategoryCircuitDto = UpdateCategoryCircuitDto;
